import type { InputBaseComponentProps } from '@material-ui/core/InputBase'
import React from 'react'
import type { MaskedInputProps } from 'react-text-mask'
import MaskedInput from 'react-text-mask'

export type PhoneNumberInputProps = InputBaseComponentProps &
  MaskedInputProps & { separator?: '-' | '.'; internationalMode?: boolean }

// use as `inputComponent` prop in InputField component
// ex: <InputField inputComponent={PhoneNumberInput} />
const PhoneNumberInput = (props: PhoneNumberInputProps) => {
  const { internationalMode = false, ...other } = props
  const separator = props.separator ?? '.'

  return (
    <MaskedInput
      {...other}
      ref={() => {
        // inputRef(ref ? ref.inputElement : null)
      }}
      showMask={false}
      mask={
        internationalMode
          ? (input) => Array.from(input).map(() => /\d/)
          : [/[1-9]/, /\d/, /\d/, separator, /\d/, /\d/, /\d/, separator, /\d/, /\d/, /\d/, /\d/]
      }
      placeholderChar={'\u2000'}
    />
  )
}

export const PhoneNumberExtensionInput = (props: PhoneNumberInputProps) => {
  const { internationalMode = false, ...other } = props

  return (
    <MaskedInput
      {...other}
      showMask={false}
      mask={internationalMode ? (input) => Array.from(input).map(() => /\d/) : [/[1-9]/, /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
    />
  )
}

export default PhoneNumberInput
